export const NAME = 'dealAdsModal';

const initialDraft = {
    id: '',
    app_name: '',
    category: '',
    ads: [
        {
            id: '',
            name: '',
            start: '',
            end: '',
            dealApplicationType: '',
            status: '',
            campaign: {
                id: null,
                lifecycle: {
                    current_state: '',
                },
                name: '',
            },
            organizationData: {
                name: '',
            },
        },
    ],
};

const initialState = {
    isDealAdsOpen: false,
    deal: {},
    loading: false,
    draft: initialDraft,
    errors: {},
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'DEAL_ADS_MODAL__DETAILS_INIT': {
            return {
                ...state,
                isDealAdsOpen: true,
                loading: true,
            };
        }
        case 'DEAL_ADS_MODAL__CLOSE_MODAL': {
            return {
                ...state,
                isDealAdsOpen: false,
                deal: {},
            };
        }
        case 'DEAL_ADS_MODAL__DETAILS_DATA_END': {
            return {
                ...state,
                draft: action.payload.deal,
                loading: false,
                deal: action.payload.deal,
            };
        }
        case 'DEAL_ADS_MODAL__DETAILS_DATA_ERROR': {
            return {
                ...state,
                isDealAdsOpen: false,
                loading: false,
                deal: {},
            };
        }
        default: {
            return state;
        }
    }
}
